<template lang="pug">
  .b2b-table-genrals-received
    //- Filtros Tabla Servicios
    b2b-filters-genrals-received(:filter-options='options')

    ods-table(
      :data='genralsReceived.tableData',
      :default-sort="{prop: 'name', genral: 'ascending'}",
      style='width: 100%',
      @sort-change='genralOnServer',
      @cell-mouse-enter='handleCellMouseEnter',
      @selection-change='handleSelectionChange',
      highlight-current-row='',
      size='small',
      fit)
      ods-table-column(
        type='selection',
        width='55')
      ods-table-column(
        prop='buyerName',
        :label='$t("genral.genral_entity_table.buyer")',
        :show-overflow-tooltip='true',
        v-if='isShowBuyerGenralReceived',
        sortable='')
      ods-table-column(
        prop='sellerName',
        :label='$t("genral.genral_entity_table.seller")',
        :show-overflow-tooltip='true',
        v-if='isShowSellerGenralReceived',
        sortable='')
      ods-table-column(
        prop='description',
        :label='$t("genral.genral_entity_table.description")',
        v-if='isShowDescriptionGenralReceived',
        sortable='')
        template(slot-scope='scope')
          ods-tooltip(placement='top')
            template(slot='content')
              | {{ formatterTooltipDesc(scope.row, scope.column) }}
            div.text-overflow-tooltip
              | {{ formatterDesc(scope.row, scope.column) }}
      ods-table-column(
        prop='genralNumber',
        :label='$t("genral.genral_entity_table.num_genral")',
        :show-overflow-tooltip='true',
        v-if='isShowNumGenralReceived',
        sortable='')
      ods-table-column(
        prop='creationDateTime',
        :label='$t("genral.genral_entity_table.date_creation")',
        align='center',
        :show-overflow-tooltip='true',
        v-if='isShowDateCreationGenralReceived',
        :formatter="formatterDateTime",
        sortable='')
      ods-table-column(
        prop='issueDateTime',
        :label='$t("order.order_entity_table.date_issue")',
        align='center',
        :show-overflow-tooltip='true',
        v-if='isShowDateIssueGenralReceived',
        :formatter="formatterDate",
        sortable='')
      ods-table-column(
        prop='statusId',
        :label='$t("genral.genral_entity_table.status")',
        v-if='isShowStatusGenralReceived',
        sortable='')
        template(slot-scope='scope')
          ods-tooltip(placement='top')
            template(slot='content')
              | {{ formatterTooltipStatus(scope.row, scope.column) }}
            div.text-overflow-tooltip
              | {{ formatterStatus(scope.row, scope.column) }}
      ods-table-column(
        prop='projectName',
        :label='$t("genral.genral_entity_table.services")',
        :show-overflow-tooltip='true',
        v-if='isShowServiceGenralReceived',
        sortable='')
      ods-table-column(width='130',
        prop='communicationMethod',
        :label='$t("invoices.filters.communication_method.reception.value")',
        :show-overflow-tooltip='true',
        v-if='isShowRecepcionGenralReceived',
        :formatter='formatterCommunicationMethod'
        sortable='')

      //- Ocultas por defecto
      ods-table-column(
        label,
        :render-header='renderHeaderActions',
        width='120')
        template(slot-scope='scope' placement='center')
          //-Descargar pdf
          ods-tooltip(placement='left')
            template(slot='content')
              | {{ $t('genral.genral_detail.download_pdf_buttons_tooltip') }}
            ods-button(
              style=' padding-left: 0px; padding-right: 0px;'
              type='neutral',
              icon-position='left'
              @click="handleDownloadPdf(scope.row)")
              ods-icon(name='download', size='16')
          //- detalle
          ods-tooltip(placement='left')
            template(slot='content')
              | {{ $t('invoices.tooltip.detail') }}
            ods-button(
              style=' padding-left: 0px; padding-right: 0px;'
              type='neutral',
              @click='handleGoDetail(scope.row)')
              ods-icon(name='search', size='16')
    ods-row.b2b-table-genrals-received__pagination(v-if='genralsReceived.totalGenralsReceived > 0')
      ods-col.b2b-table-delivery-notes-emit__pagination--left(:span='4')
        ods-tooltip(:content='$t("invoices.buttons.download_csv_tooltip")', placement='bottom')
          ods-button(
            type='primary',
            size='mini',
            round='',
            icon='ods-icon-download'
            style='display:inline;'
            @click='handleDownloadCsv')
            | CSV
      //- Paginación Tabla
      ods-col.b2b-table-genrals-received__pagination--right(:span='20')
        ods-pagination(
          ref='pagination',
          popper-class='b2b-pagination__dropdown',
          @size-change='handleSizeChange',
          @current-change='handleCurrentChangePagination',
          :current-page.sync='currentPage',
          :page-sizes='[20, 50, 100]',
          :page-size='20',
          layout='total, sizes, prev, pager, next, slot',
          :total='genralsReceived.totalGenralsReceived')

</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import router from '@/router/index'
import B2bFiltersGenralsReceived from '@/views/genrals/recibidos/B2bFiltersGenralsReceived'
import B2bTableMenuGenralsReceived from '@/views/genrals/recibidos/B2bTableMenuGenralsReceived'
import B2bTableSelectRows from '@/components/B2bTableSelectRows'
import filters from './filtros-genrals-recibidos'
import Utils from '@/components/shared/Utils'
import moment from 'moment'

export default {
  name: 'b2b-table-genrals-received',
  mixins: [Utils],

  data () {
    return {
      currentRow: {},
      multipleSelection: [],
      multipleSelectionIds: [],
      // Paginación
      totalResults: 0,
      currentPage: 0
    }
  },

  computed: {
    ...mapGetters([
      'activeUser',
      'genralsReceived',
      'queryGenralsReceived',
      'isShowBuyerGenralReceived',
      'isShowSellerGenralReceived',
      'isShowNumGenralReceived',
      'isShowDescriptionGenralReceived',
      'isShowDateReceivingGenralReceived',
      'isShowDateCreationGenralReceived',
      'isShowDateIssueGenralReceived',
      'isShowStatusGenralReceived',
      'isShowServiceGenralReceived',
      'isShowRecepcionGenralReceived',
      'optionsFilterService',
      'getActiveLang'
    ])
  },

  components: {
    B2bFiltersGenralsReceived,
    B2bTableMenuGenralsReceived,
    B2bTableSelectRows
  },

  methods: {
    ...mapActions([
      'getOptionsService',
      'getGenrals',
      'queryGenralsReceivedState',
      'downloadGenralPdfMultiple',
      'downloadGenralPdf',
      'downloadGenralCsv',
      'isShowServiceGenralReceivedAction',
      'optionsFilterServiceState'
    ]),

    // Descargar 1 genral pdf - Fast Accion
    async handleDownloadPdf (genral) {
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.download_pdf')
      })
      try {
        const params = {
          genralId: genral.id,
          searchType: 'RECEIVED'
        }
        const filename = await this.downloadGenralPdf(params)
        this.$notify({
          title: this.$t('genral.genral_detail.notify.download_pdf', { file: filename }),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },
    // Descargar todos a CSV
    async handleDownloadCsv () {
      if (this.genralsReceived.totalGenralsReceived > 120000) {
        this.$notify({
          title: this.$t('genral.genral_entity_table.csv_title'),
          message: this.$t('genral.genral_entity_table.csv_message', { argumento: '120.000' }),
          type: 'Warning',
          iconClass: 'ods-icon-warning',
          position: 'top-right',
          customClass: 'b2b-notification-info',
          duration: 10000
        })
      } else {
        const load = this.$loading({
          lock: true,
          text: this.$t('msg_generics.download_csv')
        })

        const params = this.queryGenralsReceived
        try {
          params.activeLang = this.getActiveLang
          const filename = await this.downloadGenralCsv(params)

          this.$notify({
            title: this.$t('msg_generics.download_file_ok', { file: filename }),
            type: 'success',
            position: 'top-right',
            customClass: 'b2b-notification-success',
            duration: 10000
          })
        } catch (error) {
          this.getNotificationErrorMessage(error)
        } finally {
          load.close()
        }
      }
    },

    // Descarga múltiple de pdf
    async handleDownloadGenral () {
      /* let paramsValues = this.multipleSelectionIds.filter((item, index, self) => {
        return index === self.indexOf(item)
      })
      let load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.download_pdf')
      })
      console.log('handleDownloadGenral() VALUES ->', paramsValues)
      try {
        let params = {
          genralsIds: paramsValues,
          searchType: 'RECEIVED'
        }
        const filename = await this.downloadGenralPdfMultiple(params)
        this.$notify({
          title: this.$t('genral.genral_detail.notify.download_pdf', {file: filename}),
          type: 'success',
          position: 'top-right',
          customClass: 'b2b-notification-success',
          duration: 10000
        })
      } catch (error) {
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      } */
    },

    /* Ordenar Tabla */
    async genralOnServer ({ column, genral, prop }) {
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.genral_table')
      })
      try {
        let stringSort = ''
        const dataQuery = {
          query: {}
        }

        if (genral === 'descending') {
          genral = 'DESC'
        } else if (genral === 'ascending') {
          genral = 'ASC'
        } else {
          genral = 'ASC'
        }

        if (!prop) {
          prop = 'creationDateTime'
        } else {
          switch (prop) {
            case 'buyerName':
              prop = 'partyByIdBuyer.tradeName'
              break
            case 'sellerName':
              prop = 'partyByIdSeller.tradeName'
              break
            case 'statusId':
              prop = 'statusDocument.status'
              break
          }
        }
        stringSort = prop + ',' + genral
        this.queryGenralsReceived.sort = stringSort
        await this.queryGenralsReceivedState(this.queryGenralsReceived)
        dataQuery.query = this.queryGenralsReceived
        const response = await this.getGenrals(dataQuery)
        this.totalResults = response.data.totalElements
      } catch (error) {
        console.log('genralOnServer CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    /* Recoger Id de la Fila en la que esta el ratón */
    handleCellMouseEnter (row, column, cell, event) {
      this.currentRow = row
    },

    /* Manejo de la selección múltiple */
    handleSelectionChange (val) {
      this.multipleSelection = val
      console.log(this.multipleSelection)
      if (val.length === 0) {
        this.multipleSelection = []
      }

      this.multipleSelectionIds = this.multipleSelection.map(item => item.id)
      if (val.length > 0) {
        const projects = []
        const buyers = []
        const sellers = []
        const status = []

        this.multipleSelection.forEach(r => {
          if (projects.indexOf(r.projectName) < 0) projects.push(r.projectName)
          if (buyers.indexOf(r.buyerName) < 0) buyers.push(r.buyerName)
          if (sellers.indexOf(r.sellerName) < 0) sellers.push(r.sellerName)
          if (status.indexOf(r.statusId) < 0) status.push(r.statusId)
        })
      }
    },
    // Formatear metodo de envio
    formatterCommunicationMethod (row, column) {
      if (row[column.property]) return this.$t('communication_method.' + row[column.property])
      else return ''
    },
    /* Ir al detalle */
    handleGoDetail (genral) {
      console.log('Detalle del genral: ', this.currentRow.genralNumber + ' id: ' + this.currentRow.id)
      sessionStorage.setItem('genralNumber', this.currentRow.genralNumber)
      router.push({
        name: 'genral-received-detail',
        params: {
          genralId: this.currentRow.id,
          genralNumber: this.currentRow.genralNumber
        }
      })
    },
    // Formatear estado
    formatterStatus (row, column) {
      if (row.statusId != null && row.statusId === 'REJECTED') {
        if (row.rejectSeller) {
          const REJECTED_SELLER = 'REJECTED_SELLER'
          return this.$t('genral_status.' + REJECTED_SELLER)
        } else {
          return this.$t('genral_status.' + row.statusId)
        }
      } else {
        // Distinto de rechazada
        return row.statusId != null ? this.$t('genral_status.' + row.statusId) : null
      }
    },

    formatterTooltipStatus (row, column) {
      if (row.messageStatus && row.messageStatus !== '') return row.messageStatus
      else return this.formatterStatus(row, column)
    },

    formatterDesc (row, column) {
      if (row.description && row.description !== '' && row.description.length > 40) { return row.description.substring(0, 39) } else return row.description
    },
    formatterTooltipDesc (row, column) {
      if (row.description && row.description !== '') { return row.description }
    },

    /* Formatear columna: Fecha */
    formatterDate (row, column) {
      if (row[column.property]) {
        const date = moment(row[column.property])
        return date.format(this.$t('date_format'))
      }
      return this.$t('msg_generics.no_date')
    },

    /* Formatear columna: Fecha */
    formatterDateTime (row, column) {
      if (row[column.property]) {
        const date = moment(row[column.property])
        return date.format(this.$t('date_format_long'))
      }
      return this.$t('msg_generics.no_date')
    },

    /* Renderizar Componente Menu Columnas */
    renderHeaderActions: h => {
      return <B2bTableMenuGenralsReceived />
    },

    /* Tamaño de la Tabla */
    async handleSizeChange (val) {
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.size_table')
      })
      try {
        const dataQuery = {
          query: {
            searchType: 'RECEIVED'
          }
        }
        this.queryGenralsReceived.size = val
        await this.queryGenralsReceivedState(this.queryGenralsReceived)
        dataQuery.query = this.queryGenralsReceived
        const response = await this.getGenrals(dataQuery)
        this.totalResults = response.data.totalElements
      } catch (error) {
        console.log('handleSizeChange CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    /* Paginación */
    async handleCurrentChangePagination (val) {
      const load = this.$loading({
        lock: true,
        text: this.$t('msg_generics.pagination_table')
      })
      try {
        const dataQuery = {
          query: {}
        }

        this.queryGenralsReceived.page = val - 1
        await this.queryGenralsReceivedState(this.queryGenralsReceived)
        dataQuery.query = this.queryGenralsReceived

        const response = await this.getGenrals(dataQuery)
        this.totalResults = response.data.totalElements
      } catch (error) {
        console.log('handleCurrentChangePagination CATCH: ', error)
        this.getNotificationErrorMessage(error)
      } finally {
        load.close()
      }
    },

    async getNotificationErrorMessage (error) {
      let errorSms = ''
      let statusCode = null

      statusCode = error.status
      switch (statusCode) {
        case 400:
          errorSms = error.data.message
          break
        case 401:
          errorSms = this.$t('error.e401')
          break
        case 403:
          errorSms = this.$t('error.e403')
          break
        case 404:
          errorSms = error.data.message
          if (errorSms === undefined && error.config.responseType === 'blob') {
            errorSms = this.$t('msg_generics.error_download_not_found')
          }
          break
        case 409:
          errorSms = error.data.message
          break
        case 500:
          errorSms = this.$t('error.e500')
          if (errorSms === undefined && error.config.responseType === 'blob') {
            errorSms = this.$t('msg_generics.error_download_not_found')
          }
          break
        default:
          errorSms = this.$t('error.default')
          break
      }
      error.data.message = errorSms
      this.showNotificationError(error)
    }
  },

  async created () {
    const load = this.$loading({
      lock: true,
      text: this.$t('msg_generics.load_init')
    })
    try {
      const dataQuery = { query: {} }
      this.options = filters.filters
      const dataQueryProj = { page: 0, size: 1000, sort: 'name,ASC', isSender: true }
      const optionsFilterService = await this.getOptionsService(dataQueryProj)
      await this.optionsFilterServiceState(optionsFilterService)

      if (optionsFilterService.length === 1) {
        this.queryGenralsReceived.projectId = optionsFilterService[0].id
      }
      this.isShowServiceGenralReceivedAction(true)
      if (this.optionsFilterService.length < 2) {
        this.isShowServiceGenralReceivedAction(false)
      }
      dataQuery.query = this.queryGenralsReceived
      const response = await this.getGenrals(dataQuery)
      this.totalResults = response.data.totalElements
      this.currentPage = response.data.number + 1
    } catch (error) {
      console.log('getGenrals CATCH: ', error)
      this.getNotificationErrorMessage(error)
    } finally {
      load.close()
    }
  }
}

</script>

<style lang="scss" scoped>
.b2b-table-genrals-received {
  ::v-deep .ods-table {
    th {
      padding: rem(0);
      padding-top: rem(4);

      .cell {
        font-weight: 500;
      }

      &:last-child {
        padding-top: rem(0);
        .cell {
          .ods-dropdown {
            line-height: 32px;
          }
        }
      }
      .cell:last-child {
        .ods-dropdown {
          line-height: 32px;
        }
      }
    }
    &__row {
      .cell {
        .text-overflow-tooltip {
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
      .ods-button {
        padding: rem(1) rem(15) rem(0) rem(15);
        margin-left: rem(0);
        margin-right: rem(0);
        i {
          margin-left: rem(0);
        }
      }
    }
  }

  ::v-deep &__pagination {
    margin: rem(32) rem(24) rem(32) rem(24);
    &--left {
      .ods-button {
        font-size: 0.625rem;
        line-height: 1.4;
        letter-spacing: .04rem;
        text-align: center;
        i {
          &:before {
            font-size: 0.625rem;
          }
        }
      }
    }
    &--right {
      .ods-pagination {
        justify-content: flex-end;
        width: auto;
        padding-top: rem(0);
        float: right;
        &__label {
          padding-top: rem(0);
          float: right
        }
      }
    }
  }

  ::v-deep td.colorred div{
    color:red;
  }
}
</style>
